export default "__VITE_ASSET__1db746fa__"